/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CbsComplete/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import CbsLogo from 'DesignSystem/Images/CbsLogo/index'
import GreyfinchBird from 'DesignSystem/Svgs/GreyfinchBird/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function CbsComplete({
  children,
  viewPath = "/App/Widget/Content/Questions/CbsComplete"
  
}) {
  let isBefore = useIsBefore()
let dtTypographyFontsizeL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.l'
        })
let dtTypographyFontweightRegular = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontWeight.regular'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtTypographyFontsizeS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.s'
        })
  return (<React.Fragment
>
<div
  data-testid="CbsComplete.Vertical"
  data-view-path={viewPath}
 style={{'--o-1-Zb6u1L': isBefore ? 0 : 1}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="CbsComplete.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<CbsLogo
  viewPath={`${viewPath}/CbsLogo`}
 width={300}
 height="auto"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 textAlign="center"
 fontSize={dtTypographyFontsizeL}
 fontWeight={dtTypographyFontweightRegular}
 marginTop={48}
 text="Thank you! We'll be in touch soon."
 hyphens="none"
/>
</div>
<div
  data-testid="CbsComplete.Logo"
  data-view-path={viewPath}
 style={{'--pl-2-Zb6u1L': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-3-Zb6u1L': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-4-Zb6u1L': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Logo}`}
>
<GreyfinchBird
  viewPath={`${viewPath}/GreyfinchBird`}
 height={42}
 width={42}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color="#858585"
 fontSize={dtTypographyFontsizeS}
 fontWeight={300}
 text="Powered By Greyfinch"
/>
</div>
</div>
{children}
</React.Fragment>)
}